export const QueryKeys = {
  AuthToken: "authToken",
  Infoboard: "infoboard",
} as const;
